import { defineMessages } from 'react-intl'

export default defineMessages({
  notificationInfo: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.info',
    defaultMessage: 'Notification Info'
  },
  summary: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.summary',
    defaultMessage: 'Summary'
  },
  notificationDetail: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail',
    defaultMessage: 'Notification Detail'
  },
  sendNotificationDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.sendNotificationAudience.description',
    defaultMessage: 'Send a notification to a specified audience based on rules.'
  },
  audienceTargetingRulePrefixText: {
    id: 'SpaceAppBuilderFeaturesPage.operation.sendNotificationAudience.rulePrefixText',
    defaultMessage: 'This notification will be sent to all users'
  },
  deleteNotificationAudienceRulePrefixText: {
    id: 'SpaceAppBuilderFeaturesPage.operation.deleteNotificationAudience.rulePrefixText',
    defaultMessage: 'This notification will be deleted for all users'
  },
  TextBlock: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.text',
    defaultMessage: 'Text Block'
  },
  textBlockContentsRequired: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.textBlockRequired',
    defaultMessage: 'Detail text block contents required'
  },
  FactSet: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.label',
    defaultMessage: 'Label Value'
  },
  Image: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.image',
    defaultMessage: 'Image'
  },
  ConfigurationStepDefaultPriority: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.Priority.Default',
    defaultMessage: 'Priority'
  },
  ConfigurationStepDefaultPriorityInformational: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.Priority.Informational',
    defaultMessage: 'Informational'
  },
  ConfigurationStepDefaultPriorityImportant: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.Priority.Important',
    defaultMessage: 'Important'
  },
  ConfigurationStepDefaultPriorityCritical: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.Priority.Critical',
    defaultMessage: 'Critical'
  },
  DataCollectionSet: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.dataCollectionSet',
    defaultMessage: 'Data Collection Set'
  },
  PriorityError: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.PriorityError',
    defaultMessage: 'Please select a priority.'
  },
  'Input.Text': {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.inputText.title',
    defaultMessage: 'Text Input'
  },
  'Input.Text.type': {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.inputText.type',
    defaultMessage: 'Text String'
  },
  'Input.Text.typeRequired': {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.inputText.typeRequired',
    defaultMessage: 'Required Text String'
  },
  insertInputLabel: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.input.insertLabel',
    defaultMessage: '[define input label above]'
  },
  ButtonBlock: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.button',
    defaultMessage: 'Action Set'
  },
  actionSet: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.actionSet',
    defaultMessage: 'Action Set'
  },
  click: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.buttonPlaceholder',
    defaultMessage: 'Click Here'
  },
  addLabel: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.addLabel',
    defaultMessage: 'Add a label'
  },
  inputLabel: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.inputText.label',
    defaultMessage: 'Text Input Label'
  },
  required: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.inputText.required',
    defaultMessage: 'Required'
  },
  requiredStar: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.inputText.requiredStar',
    defaultMessage: '*'
  },
  addAction: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.addAction',
    defaultMessage: 'Add an action'
  },
  notificationDetailAddBlock: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.addBlock',
    defaultMessage: 'Add Block'
  },
  notificationDetailContent: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.content',
    defaultMessage: 'Content'
  },
  labelTitle: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.label.title',
    defaultMessage: 'Label'
  },
  collectionTitle: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.collection.title',
    defaultMessage: 'Collection Title'
  },
  collectionTitlePlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.collection.title.description',
    defaultMessage: 'Add a title for your data collection'
  },
  collectionToDisplay: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.collection.toDisplay',
    defaultMessage: 'Collection to display'
  },
  collectionToDisplayPlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.collection.toDisplay.description',
    defaultMessage: 'Insert array'
  },
  showCollectionFields: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.collection.showFields',
    defaultMessage: 'For each record in the collection, show fields...'
  },
  emptyDataCollection: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.collection.empty',
    defaultMessage: '- - No items added - -'
  },
  selectDataCollectionFields: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.collection.selectFields',
    defaultMessage: 'Select from available fields'
  },
  dataCollectionAdd: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.collection.add',
    defaultMessage: 'Add'
  },
  dataCollectionRemove: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.collection.remove',
    defaultMessage: 'Remove'
  },
  value: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.label.value',
    defaultMessage: 'Value'
  },
  notificationContentPlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.summary.content.placeholder',
    defaultMessage: 'Add content...'
  },
  sendAs: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.sendAs',
    defaultMessage: 'Send As'
  },
  manageSources: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.manageSources',
    defaultMessage: 'Manage Sources'
  },
  noNotificationSources: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.noNotificationSources',
    defaultMessage: 'No Notification Sources found'
  },
  audienceTargetingUserSchedule: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.audienceTargetingUserSchedule',
    defaultMessage: 'Notification will be sent to user from trigger event.'
  },
  audienceTargeting: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.audienceTargeting',
    defaultMessage: 'Audience Targeting'
  },
  selectNotificationSource: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.selectNotificationSource',
    defaultMessage: 'Select Notification Source'
  },
  notificationAudiencePlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.audiencePlaceholder',
    defaultMessage: 'Notification Audience'
  },
  summaryImageDropzone: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.summary.ImageDropzone',
    defaultMessage: 'Summary image'
  },
  notificationSummaryTitle: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.summary.title',
    defaultMessage: 'Title'
  },
  notificationSummaryTitlePlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.summary.title.placeholder',
    defaultMessage: 'Add a title...'
  },
  notificationSummaryContent: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.summary.content',
    defaultMessage: 'Summary Content'
  },
  category: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.category',
    defaultMessage: 'Category'
  },
  categoryPlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.category.placeholder',
    defaultMessage: 'Add a category...'
  },
  showRelativeToUserTimezone: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.showRelativeToUserTimezone',
    defaultMessage: 'Should notification be sent relative to user(s) timezone?'
  },
  notificationHiddenBefore: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.hiddenBefore',
    defaultMessage: 'When should this notification be sent?'
  },
  toKnow: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.toKnow',
    defaultMessage: 'To Know'
  },
  todo: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.todo',
    defaultMessage: 'To Do'
  },
  location: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.location',
    defaultMessage: 'Location'
  },
  locationDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.locationDescription',
    defaultMessage:
      'Only applies to classic toolbar client. Adding a "submit action" will auto assign the notification as To Do'
  },
  notificationHiddenBeforeTimeZone: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.notificationHiddenBeforeTimeZone',
    defaultMessage: 'In what timezone?'
  },
  notificationHiddenBeforePlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.hiddenBeforePlaceholder',
    defaultMessage: 'Date variable'
  },
  notificationExpiration: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.expiration',
    defaultMessage: 'When should this notification expire?'
  },
  days: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.days',
    defaultMessage: 'days after sent'
  },
  labelText: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.actionLabel',
    defaultMessage: 'Label'
  },
  style: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.style',
    defaultMessage: 'Style'
  },
  interactionType: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.interactionType',
    defaultMessage: 'Interaction type'
  },
  interactionTypePlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.interactionTypePlaceholder',
    defaultMessage: 'Please select an Interaction Type'
  },
  deleteActionFeature: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.deleteActionFeature',
    defaultMessage: 'Delete feature'
  },
  url: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.url',
    defaultMessage: 'URL'
  },
  submit: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.submit',
    defaultMessage: 'Submit'
  },
  action: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.action',
    defaultMessage: 'Action {index}'
  },
  urlPlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.urlPlaceholder',
    defaultMessage: 'Enter a URL'
  },
  showOnSummary: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.showOnSummary',
    defaultMessage: 'Show on summary card'
  },
  enforceValidation: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.enforceValidation',
    defaultMessage: 'Enforce validation on required fields'
  },
  onSubmit: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.onSubmit',
    defaultMessage: 'On submit, pass this data...'
  },
  addDataField: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.addDataField',
    defaultMessage: 'Add data field'
  },
  addVariableInput: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.addVariableInput',
    defaultMessage: 'Add variable input'
  },
  addVariableButton: {
    id: 'SpaceAppBuilderFeaturesPage.operations.insertVariableButton',
    defaultMessage: 'Insert variable'
  },
  customEventDataValueLabel: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.customEventDataValueLabel',
    defaultMessage: 'Value / Data'
  },
  selectVariable: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.selectVariable',
    defaultMessage: 'Add a Variable'
  },
  selectResponse: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.selectResponse',
    defaultMessage: 'Add a response'
  },
  customEventDataDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.customEventDataDescription',
    defaultMessage: 'Add additional payload information from data in this feature.'
  },
  fieldName: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.fieldName',
    defaultMessage: 'Field Name'
  },
  attributeNamePlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.attributeNamePlaceholder',
    defaultMessage: 'Enter an attribute name'
  },
  defaultTriggerData: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.defaultTriggerData',
    defaultMessage: 'Default notification event data'
  },
  userID: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.user',
    defaultMessage: 'User Id'
  },
  userEmail: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.userEmail',
    defaultMessage: 'User email'
  },
  actionType: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.actionType',
    defaultMessage: 'Action Type'
  },
  triggerDataDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.triggerDataDescription',
    defaultMessage: 'This is the payload data that will be sent to your new feature when a user actions this action'
  },
  viewFeature: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.viewFeature',
    defaultMessage: 'View feature'
  },
  editDetails: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.editDetails',
    defaultMessage: 'Edit details'
  },
  attributeNameRequired: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.eventData.attributeName',
    defaultMessage: 'Enter an attribute name'
  },
  attributeValueRequired: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.eventData.attributeValueRequired',
    defaultMessage: 'Enter an attribute value'
  },
  notificationHiddenBeforeDefault: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.hiddenBefore.default',
    defaultMessage: 'Trigger time'
  },
  userLocalTimezone: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.hiddenBefore.userLocalTimezone',
    defaultMessage: "Recipient's"
  },
  utc: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.hiddenBefore.utc',
    defaultMessage: 'UTC'
  },
  notificationHiddenBeforeVariable: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.hiddenBefore.variable',
    defaultMessage: 'Date variable'
  },
  notificationHiddenBeforeTitle: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.hiddenBefore.title',
    defaultMessage: 'SEND & EXPIRE SETTINGS'
  },
  correlationId: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.correlationId',
    defaultMessage: 'Unique Notification ID'
  },
  correlationIdPlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.correlationId.placeholder',
    defaultMessage: 'Add a unique Notification ID'
  },
  correlationIdTitle: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.correlationId.title',
    defaultMessage: 'NOTIFICATION TARGETING SPECIFICATIONS'
  },
  advancedSettings: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.advancedSettings',
    defaultMessage: 'Advanced Settings'
  },
  imageGalleryReset: {
    id: 'SpaceAppBuilderFeaturesPage.imageLibrary.reset',
    defaultMessage: 'Reset'
  },
  sendNotification: {
    id: 'SpaceAppBuilderFeaturesPage.operation.sendNotification.label',
    defaultMessage: 'Send Notification'
  },
  notificationCategoryRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.notificationCategory',
    defaultMessage: 'Notification Category is a required field'
  },
  notificationDataRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.notificationDataRequired',
    defaultMessage: 'Notification Data is a required field'
  },
  notificationSourceRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.notificationSourceRequired',
    defaultMessage: 'Notification Source is a required field'
  },
  notificationAudienceRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.notificationAudience',
    defaultMessage: 'Notification Audience is a required field'
  },
  notificationBodyRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.notificationBody',
    defaultMessage: 'Notification Content is a required field'
  },
  notificationTitleRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.notificationTitle',
    defaultMessage: 'Notification Title is a required field'
  },
  notificationExpirationRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.notificationExpirationRequired',
    defaultMessage: 'Notification Expiration is a required field'
  },
  notificationHiddenBeforeRequired: {
    id: 'SpaceAppBuilderFeaturesPages.validation.notificationHiddenBeforeRequired',
    defaultMessage: 'Notification date is a required field'
  },
  notificationExpirationPositive: {
    id: 'SpaceAppBuilderFeaturesPage.validation.notificationExpirationPositive',
    defaultMessage: 'Notification Expiration must be a positive number'
  },
  interactionTypeRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.interactionTypeRequired',
    defaultMessage: 'Interaction type is a required field'
  },
  actionRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.submitActionIsRequired',
    defaultMessage: 'Action is a required field'
  },
  invalidURL: {
    id: 'SpaceAppBuilderFeaturesPage.validation.invalidURL',
    defaultMessage: 'Please enter a valid URL'
  },
  urlRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.urlIsRequired',
    defaultMessage: 'URL is a required field'
  },
  titleRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.titleIsRequired',
    defaultMessage: 'Title is a required field'
  },
  invalidCorrelationIdLength: {
    id: 'SpaceAppBuilderFeaturesPage.validation.invalidCorrelationIdLength',
    defaultMessage: 'Limit ID to 64 characters'
  },
  dateTimeFormatterVariableInputLabel: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dateTimeFormatter.variableInput.label',
    defaultMessage: 'Date Variable'
  },
  dateTimeFormatterFormatInputLabel: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dateTimeFormatter.formatInput.label',
    defaultMessage: 'Date Format'
  },
  dateTimeFormatter: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dateTimeFormatter.label',
    defaultMessage: 'Date & Time Formatter'
  },
  dateTimeFormatterLongLabel: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dateTimeFormatter.long.label',
    defaultMessage: '{todayAsLong} (Long)'
  },
  dateTimeFormatterShortLabel: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dateTimeFormatter.short.label',
    defaultMessage: '{todayAsShort} (Short)'
  },
  dateTimeFormatterIncludeTimeLabel: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dateTimeFormatter.includeTime.label',
    defaultMessage: 'Include time (ex: {time})'
  },
  dateTimeFormatterPlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dateTimeFormatter.placeholder',
    defaultMessage: 'Date variable from previous steps'
  },
  deleteNotification: {
    id: 'SpaceAppBuilderFeaturesPage.operation.deleteNotification.label',
    defaultMessage: 'Delete Notification'
  },
  deleteNotificationIdLabel: {
    id: 'SpaceAppBuilderFeaturesPage.operation.deleteNotificationById.label',
    defaultMessage: 'Notification ID'
  },
  deleteNotificationIdPlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.deleteNotificationById.placeholder',
    defaultMessage: 'Enter the Notification ID'
  },
  deleteNotificationIdRequired: {
    id: 'SpaceAppBuilderFeaturesPage.operation.deleteNotificationById.required',
    defaultMessage: 'Notification ID is a required field'
  },
  factSetLabelIsRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.labelIsRequired',
    defaultMessage: 'Label is a required field'
  },
  factSetValueIsRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.valueIsRequired',
    defaultMessage: 'Value is a required field'
  },
  dataCollectionSetTitleRequired: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.dataCollectionSetTitle.required',
    defaultMessage: 'Collection Title is a required field'
  },
  dataCollectionVariableRequired: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.dataCollectionVariable.required',
    defaultMessage: 'Collection Variable is a required field'
  },
  dataCollectionSetFactsRequired: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.dataCollectionSetFacts.required',
    defaultMessage: 'At least 1 field should be selected'
  },
  dateTimeFormatVariableRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.dateTimeFormatVariableRequired',
    defaultMessage: 'Date Variable is a required field'
  },
  actionLabel: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.actionSet.actionLabel',
    defaultMessage: 'Action Label'
  }
})
